import { render, staticRenderFns } from "./itemMenu.vue?vue&type=template&id=1f7d3622"
import script from "./itemMenu.vue?vue&type=script&lang=js"
export * from "./itemMenu.vue?vue&type=script&lang=js"
import style0 from "./itemMenu.vue?vue&type=style&index=0&id=1f7d3622&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f7d3622')) {
      api.createRecord('1f7d3622', component.options)
    } else {
      api.reload('1f7d3622', component.options)
    }
    module.hot.accept("./itemMenu.vue?vue&type=template&id=1f7d3622", function () {
      api.rerender('1f7d3622', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/itemMenu.vue"
export default component.exports